// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Payment-container-RVH3q {
	width: 100%;
	max-width: var(--max-listing-width);
	margin: 0 auto;
}

.Payment-pageContainer-wupSM {
	width: 1080px;
	max-width: 1080px;
}

.Payment-bookItPanel-UsuSg {
	font-size: 16px;
	padding: 5px;
}

.Payment-textLeft-ikKeg {
	text-align: left;
}

.Payment-textRight-k3hXa {
	text-align: right;
}

.Payment-textGray-keitb {
	font-size: 14px;
}

.Payment-chevronIcon-HnRf4 {
	font-size: 1.5em;
	margin-top: 10px;
	font-weight: normal;
	font-style: normal;
}

.Payment-checkInDate-Q7OvT {
	font-size: 18px;
	color: var(--common-link-color);
	margin-bottom: 6px;
}

.Payment-editLink-Kk_Iw {
	line-height: 26px;
}

.Payment-pullLeft-rB5GJ {
	float: left;
}

.Payment-pullRight-or7S5 {
	float: right;
}

.Payment-h3-qQbrz {
	font-size: 24px;
	font-weight: normal;
}

.Payment-bookItDetails-kBBNH {
	font-size: 16px;
}

.Payment-space4-v9Ls8 {
	margin-bottom: 24px;
}

.Payment-spaceTop1-sS8lr {
	margin-top: 6px;
}

.Payment-spaceTop2-kxw01 {
	margin-top: 12px;
}

.Payment-spaceTop3-wm9V4 {
	margin-top: 18px;
}

.Payment-space2-CUqg0 {
	margin-bottom: 12px;
}

.Payment-space3-cWOwu {
	margin-bottom: 18px;
}

.Payment-textArea-Z7klR {
	height: 110px !important;
	border-radius: 0px;
	margin-top: 12px;
}

.Payment-houseRulesPanel-_6fwm {
	background-color: var(--common-gray-bg-color);
	border-style: none;
	margin-top: 37px;
}

.Payment-houseRules-UYjFY {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.Payment-houseRuleContent-ldKn_ {
	white-space: pre-wrap !important;
	margin: 0;
	padding: 0;
	background-color: transparent;
	font-family: inherit;
	font-size: inherit;
	white-space: pre;
	overflow-x: auto;
	overflow-y: auto;
	max-height: 60vh;
	border: none;
	border-radius: 0;
	word-break: normal;
	color: inherit;
}

.Payment-circleIcon-FE0Sp {
	font-size: 19px;
	line-height: 1;
	font-weight: normal;
	font-style: normal;
	color: var(--common-link-color);
	display: block;
	float: right;
}

.Payment-textCenter-jPViS {
	text-align: center;
}

.Payment-button-W_fkx {
	border-color: var(--btn-primary-bg-hover);
	background-color: var(--btn-primary-bg-hover);
	color: var(--white-text);
	font-size: 14px;
}

.Payment-button-W_fkx:hover {
	background: rgba(54, 50, 119, 0.8);
}

.Payment-button-W_fkx:focus {
	border-color: #0074c2;
	-webkit-box-shadow: 0 0 8px rgba(0, 116, 194, 0.6);
	        box-shadow: 0 0 8px rgba(0, 116, 194, 0.6);
}

.Payment-btnPrimary-rTkux {
	border-color: var(--btn-primary-bg);
	background-color: var(--btn-primary-bg);
	color: var(--white-text);
}

.Payment-btnPrimary-rTkux:hover,
.Payment-btnPrimary-rTkux:focus,
.Payment-btnPrimary-rTkux:active,
.Payment-btnPrimary-rTkux:active:hover,
.Payment-btnPrimary-rTkux:active:focus {
	border-color: var(--btn-primary-bg-hover) !important;
	background-color: var(--btn-primary-bg-hover) !important;
	color: var(--white-text);
}

.Payment-paymentHeader-PS99Y {
	padding: 5px;
	font-size: 16px;
}

.Payment-headerDivider-wWZue {
	border-top-width: 2px;
	margin: 4px 0px;
}

.Payment-textLeft-ikKeg {
	text-align: left;
}

.Payment-textLight-_lTcy {
	color: var(--modalText-color);
}

.Payment-countryName-xcdP3 {
	margin: 0px 0px 8px;
}

.Payment-textRegular-VOXJN {
	font-weight: normal;
	color: var(--common-text-color);
	margin: 0px;
	word-wrap: break-word;
	font-size: 19px;
	line-height: 24px;
	padding-top: 0px;
	padding-bottom: 0px;
}

.Payment-selectContainer-FQLul {
	font-size: 19px;
	line-height: 24px;
	color: var(--common-text-color);
	position: relative;
	display: block;
}

.Payment-formControlSelect-ONG_7 {
	height: 48px;
	border-radius: 6px;
	font-size: 16px;
	padding: 12px 20px;
	width: 100%;
	border: 1px solid var(--primary-border);
	background-color: var(--primary-white-bg);
	color: var(--common-text-color);
	display: inline-block;
	overflow: hidden;
	-webkit-appearance: none;
	   -moz-appearance: none;
	        appearance: none;
	-webkit-box-shadow: unset;
	        box-shadow: unset;
}

.Payment-summaryCard-IJZrk {
	background: var(--common-gray-bg-color);
	border: 1px solid var(--primary-border);
	border-radius: 12px;
	padding: 24px;
}

.Payment-colCenter-Tv_JB {
	float: none;
	margin-left: auto;
	margin-right: auto;
}

.Payment-backgroundCover-PszZo {
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat
}

.Payment-bannerImage-dOssq {
	height: 199px;
	border-radius: 6px;
}

.Payment-hostProfilePhoto-FbLKH {
	margin-bottom: 0;
	margin-right: 30px;
	margin-top: -25px;
}

.Payment-profileAvatarSection-BAJ34 {
	position: absolute;
	top: 12px;
	right: 12px;
}

.Payment-profileAvatarLink-x7Cns {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	overflow: hidden;
	background-color: var(--common-gray-bg-color);
	border-radius: 50%;
	border: 2px solid var(--primary-white-bg);
}

.Payment-profileAvatar-LishZ {
	height: 60px;
	width: 60px;
}

.Payment-panelHeader-DMJV1 {
	border-radius: 0;
	width: 100%;
	display: block;
	color: var(--common-text-color);
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
}

.Payment-textMuted-ZnuhA {
	color: var(--modalText-color);
	font-size: 16px;
}

.Payment-textMedium-R64Ug {
	font-size: 14px
}

.Payment-textLarge-vfM7u {
	font-size: 24px;
	line-height: 30px;
}

.Payment-listStyle-ktV7H {
	margin-bottom: 0;
	padding-left: 0;
	list-style: none;
}

.Payment-noBorder-BTOFm {
	border: 0px none !important;
}

.Payment-tableText-tz7gh {
	font-weight: normal;
	color: var(--common-text-color);
}

.Payment-totalText-Ubj9k {
	border: 0;
	padding: 0;
	width: 100%;
	background: transparent;
	text-align: start;
	cursor: default;
	pointer-events: none;
	font-size: 24px;
	line-height: 30px;
}

.Payment-totalValue-xSkBU {
	border-top: 1px solid var(--primary-border);
	border-color: rgba(220, 224, 224, 0.5);
	content: "";
	top: -1px;
	height: 1px;
	left: 20px;
	right: 20px;
}

.Payment-space1-QIrv9 {
	margin-bottom: 6px;
}

a {
	text-decoration: none;
}

a:hover {
	cursor: pointer;
}

.Payment-horizondalLine-Uw3aN {
	margin-top: 18px;
	margin-bottom: 18px;
	border: 0;
	border-top: 1px solid var(--primary-border);
}

.Payment-errorMessage-VcIzk {
	color: var(--alert-color);
	font-size: 14px;
	margin-bottom: 10px;
	display: block;
}

.Payment-avatarImageGrid-Vz1Hh {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 20px;
}

.Payment-positionRelative-PHRpZ {
	position: relative;
}

.Payment-starFlex-OsmFf {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.Payment-tableFlex-kP_YZ {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.Payment-cancellationSectionPayment-GS7Vl {
	padding: 26px;
	border: 1px solid var(--primary-border);
	border-radius: 12px;
}

.Payment-hrLineSidePanelMargin-g67GU {
	margin: 12px 0px;
}

.Payment-marginLeft-aDQhV {
	margin-left: 12px;
}

.Payment-specialPriceIcon-WTy3Y {
	display: none;
	position: absolute;
}

.Payment-paymentToolTipContainer-KaX75:hover .Payment-specialPriceIcon-WTy3Y {
	display: block;
}

.Payment-paymentToolIcon-hWJ3a {
	width: 19px;
}

.Payment-paymentFlexDirection-ytbiW {
	-webkit-box-orient: horizontal;
	-webkit-box-direction: normal;
	    -ms-flex-direction: row;
	        flex-direction: row;
}

@media screen and (max-width: 991px) {
	.Payment-summaryCard-IJZrk {
		margin-top: 20px;
	}

	.Payment-paymentFlexDirection-ytbiW {
		-webkit-box-orient: vertical;
		-webkit-box-direction: reverse;
		    -ms-flex-direction: column-reverse;
		        flex-direction: column-reverse;
	}
}

@media screen and (max-width: 767px) {
	.Payment-noPaddingRight-Bje1n {
		padding-right: 0;
	}

	.Payment-arrowMargin-bnK5Q {
		margin: 0 15px;
	}

}`, "",{"version":3,"sources":["webpack://./src/components/Payment/Payment.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,mCAAmC;CACnC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,6CAA6C;CAC7C,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;;AAEA;CACC,gCAAgC;CAChC,SAAS;CACT,UAAU;CACV,6BAA6B;CAC7B,oBAAoB;CACpB,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;CAChB,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,kBAAkB;CAClB,+BAA+B;CAC/B,cAAc;CACd,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yCAAyC;CACzC,6CAA6C;CAC7C,wBAAwB;CACxB,eAAe;AAChB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,qBAAqB;CACrB,kDAA0C;SAA1C,0CAA0C;AAC3C;;AAEA;CACC,mCAAmC;CACnC,uCAAuC;CACvC,wBAAwB;AACzB;;AAGA;;;;;CAKC,oDAAoD;CACpD,wDAAwD;CACxD,wBAAwB;AACzB;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,+BAA+B;CAC/B,WAAW;CACX,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,+BAA+B;CAC/B,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,WAAW;CACX,uCAAuC;CACvC,yCAAyC;CACzC,+BAA+B;CAC/B,qBAAqB;CACrB,gBAAgB;CAChB,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,yBAAiB;SAAjB,iBAAiB;AAClB;;AAEA;CACC,uCAAuC;CACvC,uCAAuC;CACvC,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,kCAAkC;CAClC;AACD;;AAEA;CACC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,gBAAgB;CAChB,6CAA6C;CAC7C,kBAAkB;CAClB,yCAAyC;AAC1C;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,+BAA+B;CAC/B,eAAe;CACf,oBAAoB;CACpB,8CAA8C;AAC/C;;AAEA;CACC,6BAA6B;CAC7B,eAAe;AAChB;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,mBAAmB;CACnB,+BAA+B;AAChC;;AAEA;CACC,SAAS;CACT,UAAU;CACV,WAAW;CACX,uBAAuB;CACvB,iBAAiB;CACjB,eAAe;CACf,oBAAoB;CACpB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,2CAA2C;CAC3C,sCAAsC;CACtC,WAAW;CACX,SAAS;CACT,WAAW;CACX,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;CACT,2CAA2C;AAC5C;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,uCAAuC;CACvC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,8BAAmB;CAAnB,6BAAmB;KAAnB,uBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,4BAA8B;EAA9B,8BAA8B;MAA9B,kCAA8B;UAA9B,8BAA8B;CAC/B;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,cAAc;CACf;;AAED","sourcesContent":[".container {\n\twidth: 100%;\n\tmax-width: var(--max-listing-width);\n\tmargin: 0 auto;\n}\n\n.pageContainer {\n\twidth: 1080px;\n\tmax-width: 1080px;\n}\n\n.bookItPanel {\n\tfont-size: 16px;\n\tpadding: 5px;\n}\n\n.textLeft {\n\ttext-align: left;\n}\n\n.textRight {\n\ttext-align: right;\n}\n\n.textGray {\n\tfont-size: 14px;\n}\n\n.chevronIcon {\n\tfont-size: 1.5em;\n\tmargin-top: 10px;\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n\n.checkInDate {\n\tfont-size: 18px;\n\tcolor: var(--common-link-color);\n\tmargin-bottom: 6px;\n}\n\n.editLink {\n\tline-height: 26px;\n}\n\n.pullLeft {\n\tfloat: left;\n}\n\n.pullRight {\n\tfloat: right;\n}\n\n.h3 {\n\tfont-size: 24px;\n\tfont-weight: normal;\n}\n\n.bookItDetails {\n\tfont-size: 16px;\n}\n\n.space4 {\n\tmargin-bottom: 24px;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px;\n}\n\n.space2 {\n\tmargin-bottom: 12px;\n}\n\n.space3 {\n\tmargin-bottom: 18px;\n}\n\n.textArea {\n\theight: 110px !important;\n\tborder-radius: 0px;\n\tmargin-top: 12px;\n}\n\n.houseRulesPanel {\n\tbackground-color: var(--common-gray-bg-color);\n\tborder-style: none;\n\tmargin-top: 37px;\n}\n\n.houseRules {\n\tdisplay: flex;\n}\n\n.houseRuleContent {\n\twhite-space: pre-wrap !important;\n\tmargin: 0;\n\tpadding: 0;\n\tbackground-color: transparent;\n\tfont-family: inherit;\n\tfont-size: inherit;\n\twhite-space: pre;\n\toverflow-x: auto;\n\toverflow-y: auto;\n\tmax-height: 60vh;\n\tborder: none;\n\tborder-radius: 0;\n\tword-break: normal;\n\tcolor: inherit;\n}\n\n.circleIcon {\n\tfont-size: 19px;\n\tline-height: 1;\n\tfont-weight: normal;\n\tfont-style: normal;\n\tcolor: var(--common-link-color);\n\tdisplay: block;\n\tfloat: right;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.button {\n\tborder-color: var(--btn-primary-bg-hover);\n\tbackground-color: var(--btn-primary-bg-hover);\n\tcolor: var(--white-text);\n\tfont-size: 14px;\n}\n\n.button:hover {\n\tbackground: rgba(54, 50, 119, 0.8);\n}\n\n.button:focus {\n\tborder-color: #0074c2;\n\tbox-shadow: 0 0 8px rgba(0, 116, 194, 0.6);\n}\n\n.btnPrimary {\n\tborder-color: var(--btn-primary-bg);\n\tbackground-color: var(--btn-primary-bg);\n\tcolor: var(--white-text);\n}\n\n\n.btnPrimary:hover,\n.btnPrimary:focus,\n.btnPrimary:active,\n.btnPrimary:active:hover,\n.btnPrimary:active:focus {\n\tborder-color: var(--btn-primary-bg-hover) !important;\n\tbackground-color: var(--btn-primary-bg-hover) !important;\n\tcolor: var(--white-text);\n}\n\n.paymentHeader {\n\tpadding: 5px;\n\tfont-size: 16px;\n}\n\n.headerDivider {\n\tborder-top-width: 2px;\n\tmargin: 4px 0px;\n}\n\n.textLeft {\n\ttext-align: left;\n}\n\n.textLight {\n\tcolor: var(--modalText-color);\n}\n\n.countryName {\n\tmargin: 0px 0px 8px;\n}\n\n.textRegular {\n\tfont-weight: normal;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tword-wrap: break-word;\n\tfont-size: 19px;\n\tline-height: 24px;\n\tpadding-top: 0px;\n\tpadding-bottom: 0px;\n}\n\n.selectContainer {\n\tfont-size: 19px;\n\tline-height: 24px;\n\tcolor: var(--common-text-color);\n\tposition: relative;\n\tdisplay: block;\n}\n\n.formControlSelect {\n\theight: 48px;\n\tborder-radius: 6px;\n\tfont-size: 16px;\n\tpadding: 12px 20px;\n\twidth: 100%;\n\tborder: 1px solid var(--primary-border);\n\tbackground-color: var(--primary-white-bg);\n\tcolor: var(--common-text-color);\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tappearance: none;\n\tbox-shadow: unset;\n}\n\n.summaryCard {\n\tbackground: var(--common-gray-bg-color);\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n\tpadding: 24px;\n}\n\n.colCenter {\n\tfloat: none;\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n\n.backgroundCover {\n\tbackground-size: cover;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat\n}\n\n.bannerImage {\n\theight: 199px;\n\tborder-radius: 6px;\n}\n\n.hostProfilePhoto {\n\tmargin-bottom: 0;\n\tmargin-right: 30px;\n\tmargin-top: -25px;\n}\n\n.profileAvatarSection {\n\tposition: absolute;\n\ttop: 12px;\n\tright: 12px;\n}\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\toverflow: hidden;\n\tbackground-color: var(--common-gray-bg-color);\n\tborder-radius: 50%;\n\tborder: 2px solid var(--primary-white-bg);\n}\n\n.profileAvatar {\n\theight: 60px;\n\twidth: 60px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tcolor: var(--common-text-color);\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.textMuted {\n\tcolor: var(--modalText-color);\n\tfont-size: 16px;\n}\n\n.textMedium {\n\tfont-size: 14px\n}\n\n.textLarge {\n\tfont-size: 24px;\n\tline-height: 30px;\n}\n\n.listStyle {\n\tmargin-bottom: 0;\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n.noBorder {\n\tborder: 0px none !important;\n}\n\n.tableText {\n\tfont-weight: normal;\n\tcolor: var(--common-text-color);\n}\n\n.totalText {\n\tborder: 0;\n\tpadding: 0;\n\twidth: 100%;\n\tbackground: transparent;\n\ttext-align: start;\n\tcursor: default;\n\tpointer-events: none;\n\tfont-size: 24px;\n\tline-height: 30px;\n}\n\n.totalValue {\n\tborder-top: 1px solid var(--primary-border);\n\tborder-color: rgba(220, 224, 224, 0.5);\n\tcontent: \"\";\n\ttop: -1px;\n\theight: 1px;\n\tleft: 20px;\n\tright: 20px;\n}\n\n.space1 {\n\tmargin-bottom: 6px;\n}\n\na {\n\ttext-decoration: none;\n}\n\na:hover {\n\tcursor: pointer;\n}\n\n.horizondalLine {\n\tmargin-top: 18px;\n\tmargin-bottom: 18px;\n\tborder: 0;\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.errorMessage {\n\tcolor: var(--alert-color);\n\tfont-size: 14px;\n\tmargin-bottom: 10px;\n\tdisplay: block;\n}\n\n.avatarImageGrid {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 20px;\n}\n\n.positionRelative {\n\tposition: relative;\n}\n\n.starFlex {\n\tdisplay: flex;\n}\n\n.tableFlex {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.cancellationSectionPayment {\n\tpadding: 26px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n}\n\n.hrLineSidePanelMargin {\n\tmargin: 12px 0px;\n}\n\n.marginLeft {\n\tmargin-left: 12px;\n}\n\n.specialPriceIcon {\n\tdisplay: none;\n\tposition: absolute;\n}\n\n.paymentToolTipContainer:hover .specialPriceIcon {\n\tdisplay: block;\n}\n\n.paymentToolIcon {\n\twidth: 19px;\n}\n\n.paymentFlexDirection {\n\tflex-direction: row;\n}\n\n@media screen and (max-width: 991px) {\n\t.summaryCard {\n\t\tmargin-top: 20px;\n\t}\n\n\t.paymentFlexDirection {\n\t\tflex-direction: column-reverse;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.noPaddingRight {\n\t\tpadding-right: 0;\n\t}\n\n\t.arrowMargin {\n\t\tmargin: 0 15px;\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Payment-container-RVH3q`,
	"pageContainer": `Payment-pageContainer-wupSM`,
	"bookItPanel": `Payment-bookItPanel-UsuSg`,
	"textLeft": `Payment-textLeft-ikKeg`,
	"textRight": `Payment-textRight-k3hXa`,
	"textGray": `Payment-textGray-keitb`,
	"chevronIcon": `Payment-chevronIcon-HnRf4`,
	"checkInDate": `Payment-checkInDate-Q7OvT`,
	"editLink": `Payment-editLink-Kk_Iw`,
	"pullLeft": `Payment-pullLeft-rB5GJ`,
	"pullRight": `Payment-pullRight-or7S5`,
	"h3": `Payment-h3-qQbrz`,
	"bookItDetails": `Payment-bookItDetails-kBBNH`,
	"space4": `Payment-space4-v9Ls8`,
	"spaceTop1": `Payment-spaceTop1-sS8lr`,
	"spaceTop2": `Payment-spaceTop2-kxw01`,
	"spaceTop3": `Payment-spaceTop3-wm9V4`,
	"space2": `Payment-space2-CUqg0`,
	"space3": `Payment-space3-cWOwu`,
	"textArea": `Payment-textArea-Z7klR`,
	"houseRulesPanel": `Payment-houseRulesPanel-_6fwm`,
	"houseRules": `Payment-houseRules-UYjFY`,
	"houseRuleContent": `Payment-houseRuleContent-ldKn_`,
	"circleIcon": `Payment-circleIcon-FE0Sp`,
	"textCenter": `Payment-textCenter-jPViS`,
	"button": `Payment-button-W_fkx`,
	"btnPrimary": `Payment-btnPrimary-rTkux`,
	"paymentHeader": `Payment-paymentHeader-PS99Y`,
	"headerDivider": `Payment-headerDivider-wWZue`,
	"textLight": `Payment-textLight-_lTcy`,
	"countryName": `Payment-countryName-xcdP3`,
	"textRegular": `Payment-textRegular-VOXJN`,
	"selectContainer": `Payment-selectContainer-FQLul`,
	"formControlSelect": `Payment-formControlSelect-ONG_7`,
	"summaryCard": `Payment-summaryCard-IJZrk`,
	"colCenter": `Payment-colCenter-Tv_JB`,
	"backgroundCover": `Payment-backgroundCover-PszZo`,
	"bannerImage": `Payment-bannerImage-dOssq`,
	"hostProfilePhoto": `Payment-hostProfilePhoto-FbLKH`,
	"profileAvatarSection": `Payment-profileAvatarSection-BAJ34`,
	"profileAvatarLink": `Payment-profileAvatarLink-x7Cns`,
	"profileAvatar": `Payment-profileAvatar-LishZ`,
	"panelHeader": `Payment-panelHeader-DMJV1`,
	"textMuted": `Payment-textMuted-ZnuhA`,
	"textMedium": `Payment-textMedium-R64Ug`,
	"textLarge": `Payment-textLarge-vfM7u`,
	"listStyle": `Payment-listStyle-ktV7H`,
	"noBorder": `Payment-noBorder-BTOFm`,
	"tableText": `Payment-tableText-tz7gh`,
	"totalText": `Payment-totalText-Ubj9k`,
	"totalValue": `Payment-totalValue-xSkBU`,
	"space1": `Payment-space1-QIrv9`,
	"horizondalLine": `Payment-horizondalLine-Uw3aN`,
	"errorMessage": `Payment-errorMessage-VcIzk`,
	"avatarImageGrid": `Payment-avatarImageGrid-Vz1Hh`,
	"positionRelative": `Payment-positionRelative-PHRpZ`,
	"starFlex": `Payment-starFlex-OsmFf`,
	"tableFlex": `Payment-tableFlex-kP_YZ`,
	"cancellationSectionPayment": `Payment-cancellationSectionPayment-GS7Vl`,
	"hrLineSidePanelMargin": `Payment-hrLineSidePanelMargin-g67GU`,
	"marginLeft": `Payment-marginLeft-aDQhV`,
	"specialPriceIcon": `Payment-specialPriceIcon-WTy3Y`,
	"paymentToolTipContainer": `Payment-paymentToolTipContainer-KaX75`,
	"paymentToolIcon": `Payment-paymentToolIcon-hWJ3a`,
	"paymentFlexDirection": `Payment-paymentFlexDirection-ytbiW`,
	"noPaddingRight": `Payment-noPaddingRight-Bje1n`,
	"arrowMargin": `Payment-arrowMargin-bnK5Q`
};
module.exports = ___CSS_LOADER_EXPORT___;
